import React from 'react'
import '../assets/css/registration.css'

function Registration(props) {
  return (
    <div className='register'>
        <a href={`${props.link}`} target="_blank">
            <span></span>
            <span></span>
            <span></span>
            <span></span>
           REGISTER FOR LIVE EVENT
        </a>
    </div>
  )
}

export default Registration